import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { Physicals } from '../../canvas/entities/Physicals';
import { Text } from './Text';

export const createText = defineCommand(
    'createText',
    'Create: Text',
    (r, [content, x, y]: [string?, number?, number?]) => {
        Physicals.create(r, Text, [x, y], t => {
            t.content = content ?? 'Some fabulous text...';
        });
    },
);
